/* KeenTrove 2026-11-03: urun galerisi buyuk gorseli 750px ve ustunde fare/parmakla surukleyerek degisir (OneCompress gibi).
   Telefon (<750px) Dawn'in kendi kaydirmasini kullanir, bu dosya orada hicbir sey yapmaz.
   Gecis, Dawn'in kucuk resim dugmesine tiklayarak yapilir; aktif kucuk resim, canli bolge ve video durdurma Dawn'da kalir. */
(function () {
  var mql = window.matchMedia('(min-width: 750px)');
  var ESIK = 50;

  function stilEkle() {
    if (document.getElementById('kt-galeri-surukle-css')) return;
    var s = document.createElement('style');
    s.id = 'kt-galeri-surukle-css';
    s.textContent =
      '@media screen and (min-width:750px){' +
      'media-gallery[data-kt-surukle] .product__media-list{touch-action:pan-y;cursor:grab;user-select:none;-webkit-user-select:none;}' +
      'media-gallery[data-kt-surukle].kt-suruklenen .product__media-list{cursor:grabbing;}' +
      'media-gallery[data-kt-surukle] .product__media-list img{-webkit-user-drag:none;}' +
      '}';
    document.head.appendChild(s);
  }

  function kur(g) {
    if (g.hasAttribute('data-kt-surukle')) return;
    var viewer = g.querySelector('[id^="GalleryViewer"]');
    var thumbs = g.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer || !thumbs) return;
    var list = viewer.querySelector('.product__media-list') || viewer;
    g.setAttribute('data-kt-surukle', '');
    stilEkle();

    var x0 = 0, y0 = 0, dx = 0, yon = null, aktif = null, kilit = false, oynadi = false, pid = null;

    function kutular() { return [].slice.call(thumbs.querySelectorAll('[data-target]')); }
    function sira() {
      var k = kutular();
      for (var i = 0; i < k.length; i++) if (k[i].querySelector('button[aria-current]')) return i;
      return 0;
    }
    function aktifOge() {
      return viewer.querySelector('[data-media-id].is-active') || viewer.querySelector('[data-media-id]');
    }
    function git(adim) {
      var k = kutular();
      if (k.length < 2) return false;
      var i = (sira() + adim + k.length) % k.length;
      var b = k[i].querySelector('button');
      if (!b) return false;
      b.click();
      return true;
    }
    function sifirla(el) {
      if (!el) return;
      el.style.transition = '';
      el.style.transform = '';
      el.style.opacity = '';
    }

    list.addEventListener('pointerdown', function (e) {
      if (!mql.matches || kilit) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('video, model-viewer, iframe, .deferred-media__poster, .oc-garrow')) return;
      x0 = e.clientX; y0 = e.clientY; dx = 0; yon = null; oynadi = false; pid = e.pointerId;
      aktif = aktifOge();
    });

    list.addEventListener('pointermove', function (e) {
      if (pid !== e.pointerId || !aktif) return;
      var mx = e.clientX - x0, my = e.clientY - y0;
      if (!yon) {
        if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        yon = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (yon === 'y') { pid = null; aktif = null; return; }
        try { list.setPointerCapture(e.pointerId); } catch (_) {}
        g.classList.add('kt-suruklenen');
      }
      dx = mx;
      oynadi = true;
      aktif.style.transition = 'none';
      aktif.style.transform = 'translateX(' + dx + 'px)';
    });

    function birak(e) {
      if (pid !== e.pointerId) return;
      pid = null;
      g.classList.remove('kt-suruklenen');
      var el = aktif; aktif = null;
      if (!el || yon !== 'x') return;
      var w = el.getBoundingClientRect().width || 1;
      if (Math.abs(dx) < Math.max(ESIK, w * 0.12) || e.type === 'pointercancel') {
        el.style.transition = 'transform .2s ease';
        el.style.transform = 'translateX(0)';
        setTimeout(function () { sifirla(el); }, 220);
        return;
      }
      var adim = dx < 0 ? 1 : -1;
      kilit = true;
      el.style.transition = 'transform .16s ease-in, opacity .16s ease-in';
      el.style.transform = 'translateX(' + (adim > 0 ? -w : w) * 0.6 + 'px)';
      el.style.opacity = '0';
      setTimeout(function () {
        sifirla(el);
        git(adim);
        var yeni = aktifOge();
        if (yeni && yeni !== el) {
          yeni.style.transition = 'none';
          yeni.style.transform = 'translateX(' + (adim > 0 ? w : -w) * 0.35 + 'px)';
          yeni.style.opacity = '0';
          yeni.getBoundingClientRect();
          yeni.style.transition = 'transform .22s ease-out, opacity .22s ease-out';
          yeni.style.transform = 'translateX(0)';
          yeni.style.opacity = '1';
          setTimeout(function () { sifirla(yeni); kilit = false; }, 240);
        } else {
          kilit = false;
        }
      }, 160);
    }
    list.addEventListener('pointerup', birak);
    list.addEventListener('pointercancel', birak);

    // Surukleme sonrasi tiklama buyutme penceresini acmasin
    list.addEventListener('click', function (e) {
      if (oynadi) { e.preventDefault(); e.stopPropagation(); oynadi = false; }
    }, true);
    list.addEventListener('dragstart', function (e) { if (mql.matches) e.preventDefault(); });
  }

  function hepsi() { document.querySelectorAll('media-gallery').forEach(kur); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi);
  else hepsi();
  document.addEventListener('shopify:section:load', hepsi);
})();
